function fileNameToCategoryName(filename) {
    if (!filename) return '';
    filename = filename.substring(0, filename.lastIndexOf('.')); // cut a file extension
    filename = filename.replace(/\.\//gm, ''); // delete './'
    return filename.replace(/\//gm, '.');
}

function makeCategory(fileName, rawCategory = '', rootTranslationCategory) {
    let category = `${rootTranslationCategory || fileNameToCategoryName(fileName)}${rawCategory ? '.' + rawCategory : ''}`;
    if (rawCategory[0] === '@') {
        category = rawCategory.substring(1); // delete first symbol '@';
    }
    if (category.startsWith('src.')) {
        category = category.replace('src.', '');
    }
    if (category.startsWith('view.')) {
        category = category.replace('view.', '');
    }
    return category;
}

module.exports = {
    fileNameToCategoryName,
    makeCategory
};